// src/hooks/useScrollReveal.js
import { useEffect } from 'react';

const useScrollReveal = (selector = '.reveal', stagger = false) => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            if (stagger) {
              entry.target.style.transitionDelay = `${index * 0.2}s`;
            }
          } else {
            entry.target.classList.remove('visible');
            if (stagger) {
              entry.target.style.transitionDelay = '0s';
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [selector, stagger]);
};

export default useScrollReveal;
